import { Injectable, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

import { ConfirmComponent } from '../components/confirm/confirm.component';
import { firstValueFrom } from 'rxjs';

export interface ConfirmOptions {
  title?: string;
  message?: string;
  acceptText?: string;
  cancelText?: string;
  warning?: string;
  oneBotton?: boolean;
  piIcon?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  pdialogService = inject(DialogService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  openConfirm(title: string = '', message: string = '', acceptText: string = 'Aceptar') {
    const dialogRef = this.pdialogService.open(ConfirmComponent, {
      data: {
        message: message,
        title: title,
        acceptText,
      },
      closable: true,
      modal: true,
    });

    return dialogRef.onClose;
  }

  confirm(options: ConfirmOptions) {
    const dialogRef = this.pdialogService.open(ConfirmComponent, {
      data: {
        message: options.message || '',
        title: options.title || 'Confirmación',
        acceptText: options.acceptText || 'Aceptar',
        cancelText: options.cancelText || 'Cancelar',
        warning: options.warning || null,
        oneBotton: options.oneBotton || false,
        piIcon: options.piIcon || null,
      },
      closable: true,
      modal: true,
    });

    return firstValueFrom(dialogRef.onClose);
  }
}
